import React from 'react';
import Image from 'next/image';
import styles from '../styles.module.scss';
import { ASSETS } from 'src/common/utils/config';

const Index = ({
  text,
  iconUrl = ASSETS.BLACK_INFO_ICON,
  wrapperStyles = {},
  iconSize = 14,
  fontSize = '12px',
  lineHeight = '16px',
}) => (
  <div className={styles.noteContainer} style={wrapperStyles}>
    <span
      className={styles.noteIcon}
      style={{
        width: `${iconSize}px`,
        minWidth: `${iconSize}px`,
        height: `${iconSize}px`,
      }}
    >
      <Image src={iconUrl} alt="note-icon" height={iconSize} width={iconSize} />
    </span>
    <div className={styles.noteText} style={{ fontSize, lineHeight }}>
      {text}
    </div>
  </div>
);

export default Index;
